module.exports = __webpack_public_path__ + "static/images/homeicon1.283dd57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeicon1.png
// module id = M2Dd
// module chunks = 0